import React, { useEffect, useState } from "react";
import IncomeCheckView from "./components/IncomeCheck";
import Error from "../../../shared/components/Error";
import { withTranslation } from "react-i18next";

const IncomeCheck = ({ i18n }) => {
  const [isError, setIsError] = useState(false);

  return isError ? <Error /> : <IncomeCheckView setIsError={setIsError} />;
};
export default withTranslation("common")(IncomeCheck);
